import { Pipe } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'dateFormat',
    standalone: false
})
export class DateFormatPipe extends DatePipe {
    override transform(value: null, format?: string, timezone?: string, locale?: string): null;
    override transform(value: Date | string | number, format?: string, timezone?: string, locale?: string): string;
    override transform(value: Date | string | number | null | undefined, format?: string, timezone?: string, locale?: string): string | null {
        return super.transform(value as Date | string | number, 'MM/dd/yyyy');
    }
}
